import tenant from '@/config/tenant'

const {
  URL,
  URL_ADMINISTRACION,
  URL_PROCESO_IMAGENES,
  URL_CARNET,
  URL_PDF,
  URL_DOCS_PETICIONES,
  VERSION,
  STORAGE_PREFIX,
  ID_CLIENTE,
  URL_PROXY,

} = tenant.api

const STORAGE_NAME = `${STORAGE_PREFIX}${VERSION}`
const INSERT_DATA_PLAYER = 'INSERT'
const INSERT_DATA_HISTORY_PLAYER = 'INSERT_HISTORY'
const UPDATE_DATA_PLAYER = 'UPDATE'
const ACTION_INSERT = 'insert'
const ACTION_UPDATE = 'update'

const ROLES = {
  SUPER: 'super',
  ADMIN: 'admin',
  CALIFICACION: 'calificacion',
  TECNICA: 'tecnica',
  SANCIONES: 'sanciones',
  CLUB: 'club',
  TESORERIA: 'tesoreria',
}
const ESTADO_JUGADOR = {
  INSCRITO: 'inscrito',
  REVISADO: 'revisado',
  CALIFICADO: 'calificado',
}
const TIPOS_JUGADOR = {
  NOVATO: 'Novato',
  JUVENIL: 'Juvenil',
  CLASIFICADO: 'Clasificado',
}
const TARJETAS = {
  AMARILLA: 'TA',
  ROJA: 'TR',
  DOBLE_TA: 'DOBLE_TA',
}
const MOTIVOS_PRINCIPALES_SANCION = {
  ACUMULACION_AMARILLAS: '1',
  ROJA: '2',
  DOBLE_TA: '3',
}
const UBICACIONES = {
  INSTITUCIONES: 'instituciones',
  CATEGORIAS: 'categorias',
  CARNET: 'carnet',
}
const DISCIPLINAS = {
  FUTBOL: '1',
  BALONCESTO: '2',
  ECUAVOLEY: '3',
}
function USER() { return JSON.parse(localStorage.getItem(STORAGE_NAME)) }
// function SET_USER(foto){
//   foto
// }

export {
  URL,
  USER,
  STORAGE_NAME,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  ROLES,
  ESTADO_JUGADOR,
  TARJETAS,
  MOTIVOS_PRINCIPALES_SANCION,
  ACTION_INSERT,
  ACTION_UPDATE,
  TIPOS_JUGADOR,
  UBICACIONES,
  URL_CARNET,
  URL_PDF,
  DISCIPLINAS,
  VERSION,
  URL_ADMINISTRACION,
  ID_CLIENTE,
  URL_DOCS_PETICIONES,
  URL_PROCESO_IMAGENES,
  URL_PROXY,
  // setUser,
}
